import { IUserEnteredSupplementDataWithComments } from '@interfaces/supplements';

import { TNewSupplementResponseMode } from '../NewSupplement.interface';

export const isOnlyCommentsMode = (mode: TNewSupplementResponseMode) =>
  mode === TNewSupplementResponseMode.NeedMoreInfo ||
  mode === TNewSupplementResponseMode.MarkAsMedication;

export const validateForm = (values: IUserEnteredSupplementDataWithComments) => {
  const errors: Partial<Record<keyof IUserEnteredSupplementDataWithComments, string | boolean>> =
    {};

  if (!values.supplementName) errors.supplementName = true;
  if (!values.companyName) errors.companyName = true;
  if (!values.linkToProductPage) errors.linkToProductPage = true;

  return errors;
};

export const validateComments = (values: IUserEnteredSupplementDataWithComments) => {
  const errors: Partial<Record<keyof IUserEnteredSupplementDataWithComments, string | boolean>> =
    {};

  if (!values.comments) errors.comments = true;

  return errors;
};
